import axios from 'axios';
import config from '@/config';

const initialState = {
  brandName: 'Skoda',
  brandID: 'C',
  primaryColor: '#000000',
  secondaryColor: '#b3b3b3',
  thirdColor: '#bb0a30',
  footerColor: '#4c4c4c',
  fonts: {
    main: 'SKODA Next W23 Regular',
    mainBold: 'SKODA Next W23 Bold',
    secondary: 'SKODA Next W23 Bold',
    third: 'SKODA Next W23 Black',
  },
};

export const brand = {
  namespaced: true,
  state: {
    ...initialState,
    specificModels: [],
    generalModels: [],
  },
  getters: {
    getBrandID(state) {
      return state.brandID;
    },
    getBrandName(state) {
      return state.brandName;
    },
    getTrademark(state) {
      return state.trademark;
    },
    getPrimaryColor(state) {
      return state.primaryColor;
    },
    getSecondaryColor(state) {
      return state.secondaryColor;
    },
    getThirdColor(state) {
      return state.thirdColor;
    },
    getFonts(state) {
      return state.fonts;
    },
    getFooterColor(state) {
      return state.footerColor;
    },
    getBrandModels(state) {
      return state.generalModels;
    },
    getSpecificModels(state) {
      return state.specificModels;
    },
  },
  actions: {
    getBrandModels({ commit }) {
      const { apiUrl, apiEndpoints } = config;

      return new Promise((resolve, reject) => {
        axios.get(apiUrl + apiEndpoints.carModels)
          .then((res) => {
            commit('setBrandModels', res.data);
            resolve(res);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },
  },
  mutations: {
    setBrandModels(state, models) {
      state.specificModels = models;
      state.generalModels = [...new Set(models.map(car => car.model))];
    },
  },
};
